// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.user.LoginHistoryInfo
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { LoginSessionInfo } from "abweb/dto/generated/user/LoginSessionInfo";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class LoginHistoryInfo {
  static createLoginHistoryInfo(currentUserSession, hasCurrentSession, sessions) {
    const retVal = new LoginHistoryInfo();
    retVal.initLoginHistoryInfo(currentUserSession, hasCurrentSession, sessions);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createLoginHistoryInfo factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadu.LoginHistoryInfo";
  }
  initFromJson(json, deserializeContext) {
    this.initLoginHistoryInfo(json.currentUserSession, json.hasCurrentSession, json.sessions != null ? TSOGUtils.decodeObjectArray(json.sessions, LoginSessionInfo, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "sessions")) : null);
  }
  initLoginHistoryInfo(currentUserSession, hasCurrentSession, sessions) {
    this._currentUserSession = currentUserSession;
    this._hasCurrentSession = hasCurrentSession;
    this._sessions = sessions;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["currentUserSession"] = this._currentUserSession;
    retVal["hasCurrentSession"] = this._hasCurrentSession;
    retVal["sessions"] = TSOGUtils.toTSOGArray(this._sessions, serializeContext);
    return retVal;
  }
  get currentUserSession() {
    return this._currentUserSession;
  }
  set currentUserSession(value) {
    this._currentUserSession = value;
  }
  get hasCurrentSession() {
    return this._hasCurrentSession;
  }
  set hasCurrentSession(value) {
    this._hasCurrentSession = value;
  }
  get sessions() {
    return this._sessions;
  }
  set sessions(value) {
    this._sessions = value;
  }
}
//# sourceMappingURL=LoginHistoryInfo.js.map
